import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { candidateBriefQueryKeys } from './queryKeys';
import type { CandidatePathParams, CandidateTouchpointApi } from './types';

const candidateTouchpointsQueryOptions = (params: CandidatePathParams) => ({
  queryKey: candidateBriefQueryKeys.touchpoints(params),
  queryFn: async () => {
    const { data } = await fetchClient.GET(
      '/jobs/{jobId}/candidates/{candidateId}/touchpoints',
      { params: { path: params } },
    );

    return data as CandidateTouchpointApi[];
  },
});

export function useCandidateTouchpointsQuery(params: CandidatePathParams) {
  return useQuery(candidateTouchpointsQueryOptions(params));
}

export function useCandidateTouchpointsSuspenseQuery(
  params: CandidatePathParams,
) {
  return useSuspenseQuery(candidateTouchpointsQueryOptions(params));
}
